const Addr_Visible_DATA = [
  {
    key: "Visible",
    value: 1,
    text: "是"
  },
  {
    key: "Disvisible",
    value: 0,
    text: "否"
  }
];
const Addr_Visible = {};
const Addr_Visible_TEXT = {};
for (let item of Addr_Visible_DATA) {
  Addr_Visible[item.key] = item.value;
  Addr_Visible_TEXT[item.value] = item.text;
}
export { Addr_Visible, Addr_Visible_TEXT };
